import React from 'react';
import { FormattedMessage } from 'react-intl';

import style from './sales-order-list-item.module.less';
import UserDateFormat from '../../../components/user-date-format';
import UserTimeFormat from '../../../components/user-time-format';
import { messages } from '../messages';

/**
 * @param {object} props
 * @param {string} props.orderNumber
 * @param {string} props.orderDate
 * @param {number} props.itemCount
 * @param {string} [props.recipientName]
 * @returns {JSX.Element}
 */
export const SalesOrderListItem = ({ orderNumber, orderDate = null, itemCount = 0, recipientName }) => {
  return (
    <div className={style['sales-order']}>
      <div>
        <div className={style['order-number']}>{recipientName || orderNumber}</div>
        <div className={style['order-date-and-items']}>
          {orderDate ? (
            <>
              <span>
                <UserDateFormat value={orderDate} />
              </span>
              <span>
                <UserTimeFormat value={orderDate} />
              </span>
              <span>&bull;</span>
            </>
          ) : null}
          <span>
            <FormattedMessage {...messages.itemCountOrders} values={{ itemCount }} />
          </span>
        </div>
      </div>
    </div>
  );
};
